import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

//Algolia search
// import InstantSearch from "vue-instantsearch";
// Vue.use(InstantSearch);

//Vue-select
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

//Icon component
import icon from "@/components/icons/icon-component.vue";
Vue.component("icon", icon);

//Tel input
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
let vueTelOptions = {
  inputOptions: {
    placeholder: "Номер телефону",
  },
};
Vue.use(VueTelInput, vueTelOptions);

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
const options = {
  timeout: 1500,
  draggable: false,
  closeOnClick: true,
};

//Vue moment
Vue.use(Toast, options);
const moment = require("moment");
require("moment/locale/uk");
Vue.use(require("vue-moment"), {
  moment,
});

//App global scss
import "@/scss/style.scss";

import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAfNssi3issHmfxP3Run4A7Uaearyag8zI",
  authDomain: "safehouse-ua.firebaseapp.com",
  projectId: "safehouse-ua",
  appId: "1:990016105883:web:ebafdc9807771e21ea853e",
  measurementId: "G-NNW3NTLCGX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// import acl from "./acl/acl";

//Firebase Auth services
import db from "./providers/db";
Vue.prototype.$db = db(app);

//Firebase Auth services
import storage from "./providers/storage";
Vue.prototype.$storage = storage(app);

//AXIOS as API
import api from "./providers/api";
Vue.prototype.$api = api;

//Strapi auth services
import auth from "./providers/auth";
Vue.prototype.$auth = auth(api);

//Translations
import i18n from "@/translations/index.js";

import IconSvg from "@/components/icons/icon-component.vue";
Vue.component("icon-svg", IconSvg);

import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);

import circleIcon from "@/components/circle-icon.vue";
Vue.component("circle-icon", circleIcon);

import NoData from "@/components/no-data.vue";
Vue.component("no-data", NoData);

// import vGoogleTranslate from "v-google-translate";
// Vue.use(vGoogleTranslate);

Vue.config.productionTip = false;

new Vue({
  // acl,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
